export const HeaderTableRegionList = ['ID', 'Region Name', 'Country', 'Action'];
